'use strict';

(function () {
  angular.module('zp').factory('PostModel', postModelFactory);

  /**@ngInject */
  function postModelFactory(SlugerService) {
    function PostModel(data) {
      this.id = data && data.id ? data.id : null;
      this.title = data && data.title ? data.title : null;
      this.url = data && data.url ? data.url : null;
      this.image = data && data.image ? data.image : null;
      this.type = data && data.type ? data.type : null;
      this.alias = SlugerService.generateSlug(this.title);
    }
    return PostModel;
  }
})();